module.exports = __webpack_public_path__ + "img/VALOR.f44131dc.png";